import * as React from 'react';
import type { SVGProps } from 'react';
const SvgColumns03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 3.6c0-.574 0-.861-.113-1.078a1.017 1.017 0 0 0-.45-.438c-.22-.107-.492-.1-1.037-.085-.199.006-.397.015-.595.032-.395.032-.789.103-1.167.296a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.198.017.396.026.595.032.545.015.817.022 1.037-.085.19-.092.353-.25.45-.438C7 21.261 7 20.974 7 20.4V3.6ZM9 20.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C9.76 22 10.04 22 10.6 22h2.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C15 21.24 15 20.96 15 20.4V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 2 13.96 2 13.4 2h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 2.76 9 3.04 9 3.6v16.8ZM18.6 2c-.545-.016-.817-.023-1.037.084-.19.092-.353.25-.45.438C17 2.739 17 3.026 17 3.6v16.8c0 .574 0 .861.113 1.078.097.188.26.346.45.438.22.107.492.1 1.037.085.199-.006.397-.015.595-.032.395-.032.789-.103 1.167-.296a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296a11.026 11.026 0 0 0-.595-.032Z"
    />
  </svg>
);
SvgColumns03.displayName = 'Columns03';
export default SvgColumns03;
